import * as Yup from 'yup';

import { FormValues } from './types';

export const initialValues: FormValues = {
  amount: '',
};

export const validationSchema = Yup.object().shape({
  amount: Yup.number().positive().required(),
});

export const generatePresets = (total: number) => {
  const roundedTo1 = Math.ceil(total);
  const roundedTo10 = Math.ceil(total / 10) * 10;
  const roundedTo100 = Math.ceil(total / 100) * 100;
  return [roundedTo1, roundedTo10, roundedTo100];
};
